var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 7.25C20.8734 7.25 23 9.37664 23 12C23 14.6234 20.8734 16.75 18.25 16.75V15.25C20.0449 15.25 21.5 13.7949 21.5 12C21.5 10.2051 20.0449 8.75 18.25 8.75V7.25Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12C1.5 9.37664 3.62665 7.25 6.25 7.25V8.75C4.45507 8.75 3 10.2051 3 12C3 13.7949 4.45507 15.25 6.25 15.25L6.25 16.75C3.62665 16.75 1.5 14.6234 1.5 12Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 2.75C9.35051 2.75 7 5.1005 7 8L7 16C7 16.4142 6.66421 16.75 6.25 16.75C5.83579 16.75 5.5 16.4142 5.5 16L5.5 8C5.5 4.27208 8.52209 1.25 12.25 1.25C15.9779 1.25 19 4.27208 19 8V16C19 19.7279 15.9779 22.75 12.25 22.75C11.8358 22.75 11.5 22.4142 11.5 22C11.5 21.5858 11.8358 21.25 12.25 21.25C15.1495 21.25 17.5 18.8995 17.5 16V8C17.5 5.1005 15.1495 2.75 12.25 2.75Z",
    fill: "#1C1B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.89fbe78a29b5daf0cbdc9bf4386e00af.svg";
export { ForwardRef as ReactComponent };